import {
  IQueryProviderResult,
  IQueryServiceResult,
} from '../../../../modules/consumer/search/types';

export enum QueryResultType {
  SERVICE = 0,
  STYLIST = 1,
  SALON = 2,
  POPULAR_SERVICE = 3,
  ALSO_SEARCHED = 4,
  LOCATION = 5,
}

export type LocationObject = {
  description?: string;
  latitude?: number;
  longitude?: number;
  place_id?: string;
};

export type SuggestedLocationObject = LocationObject & {
  terms?: { offset: number, value: string }[];
};

export type IQuerySuggestionData = (
  IQueryProviderResult | IQueryServiceResult | SuggestedLocationObject
);

export interface IQuerySuggestion {
  id: number | string;
  text: string;
  matchedSubstrings: number[] | [];
  section: QueryResultType;
  data: IQuerySuggestionData;
  testId?: string;
  subItems?: Omit<IQuerySuggestion, 'subItems'>[]
}

export interface IQuerySuggestionList {
  testId?: string;
  title: string;
  data: IQuerySuggestion[];
}

export type SearchSubmitter = (
  query: string,
  addressObject: {
    address: string;
    latitude: string | number;
    longitude: string | number;
  },
  slugged: {
    q: string;
    popover_source?: string;
    loc?: string;
    lat?: string;
    lon?: string;
  }) => void;
